import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormGroup} from "@angular/forms";
import {IAttribute, IOption} from "../add-product-form.interface";
import {ProductVariantsHelper} from "../product-variants-helper.service";
import {ProductStockStatus} from "../../../ecommerce-product.enum";

@Component({
    selector: 'db-product-price-variants',
    templateUrl: './product-price-variants.component.html',
    styleUrls: ['./product-price-variants.component.scss'],
    standalone: false
})
export class ProductPriceVariantsComponent implements OnInit {
  @Input() variantsForm: FormGroup;
  @Input() inventoryForm: FormGroup;
  @Input() variantsDialogForm: FormGroup;
  @Input() currency: { symbol: string };
  @Input() activeAttributes: IOption[] = [];
  atts = [];

  statusOptions = {
    [ProductStockStatus.IN_STOCK]: 'In stock',
    [ProductStockStatus.OUT_OF_STOCK]: 'Out of stock',
    [ProductStockStatus.ON_BACKORDER]: 'On backorder',
  };

  @Input() set attributes(atts: IAttribute[]) {
    this.atts = atts;
    this.allAttributes = atts?.map(att => ({label: att.name, value: att.id}));
  }

  allAttributes: { label: string; value: number }[] = [];
  @Output() openVariantsModal: EventEmitter<IOption[]> = new EventEmitter<IOption[]>();
  @Output() applyVariations: EventEmitter<any> = new EventEmitter<any>();

  constructor(private _variationsHelper: ProductVariantsHelper) {
  }

  get variantsDialogFormArray(): FormArray {
    return this.variantsDialogForm.get('variants') as FormArray;
  }

  get variantsFormArray(): FormArray {
    return this.variantsForm.get('variants') as FormArray;
  }

  removeVariations() {
    this.variantsDialogFormArray.clear();
    this.variantsFormArray.clear();
  }

  ngOnInit() {
  }

  removeSymbol(value: string): string {
    if (!value) return "";

    return value.replace(/\D/g, "");
  }

}
